import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Services: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="services">
      <div className="services-content">
        <h2>{t('services.title')}</h2>
        <p className="intro">{t('services.intro1')}</p>
        <p className="intro">{t('services.intro2')}</p>
        
        <div className="services-grid">
          <div className="service-card">
            <h3>{t('services.customMealPlans.title')}</h3>
            <p>{t('services.customMealPlans.description')}</p>
          </div>
          <div className="service-card">
            <h3>{t('services.personalGroupCoaching.title')}</h3>
            <p>{t('services.personalGroupCoaching.description')}</p>
          </div>
          <div className="service-card">
            <h3>{t('services.weeklyFollowUp.title')}</h3>
            <p>{t('services.weeklyFollowUp.description')}</p>
          </div>
          <div className="service-card">
            <h3>{t('services.unlimitedSupport.title')}</h3>
            <p>{t('services.unlimitedSupport.description')}</p>
          </div>
          <div className="service-card">
            <h3>{t('services.workshops.title')}</h3>
            <p>{t('services.workshops.description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services; 